export default {
  scheduleEvent: 'Ereignis erstellen',
};
